import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CouponService, ExcelService, ServiceCategoryService } from '@fitness-force/api';
import { Status } from '@fitness-force/enum';
import { AddServiceCategoryRequest, CouponServicesResponse, OfferMaster } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-coupon-service-restriction',
  templateUrl: './coupon-service-restriction.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    ButtonModule,
    SelectModule,
    TranslateModule
]
})
export class CouponServiceRestrictionComponent implements OnInit {
  @Input('tenantId') tenantId = 0;
  @Input('couponMaster') couponMaster: OfferMaster;
  @Input('visible') visible: boolean = false;
  @Input('service_ids') serviceIds: number[] = [];
  @Output('closeEvent') closeEvent: EventEmitter<any> = new EventEmitter();

  services: any[] = [];
  couponServies: CouponServicesResponse[] = [];
  selectedServices = new BehaviorSubject<CouponServicesResponse[]>([]);

  reloadList: boolean = false;

  constructor(private coupnService: CouponService,
    private translate: TranslateService,
    private excelService: ExcelService,
    private toastMessageService: ToastMessageService, private serviceCategoryService: ServiceCategoryService) {
  }


  ngOnInit(): void {
    this.BindServiceCategory();
  }

  BindServiceCategory() {
    this.serviceCategoryService.getServiceCategories(this.tenantId).subscribe({
      next: (res: any) => {
        if (res.items)
          this.services = res.items.filter((value: any) => value.status == Status.Active.toString() || value.status == Status[Status.Active]);
        else
          this.services = [];
        this.getCouponEligibleService();
      },
      error: (error: any) => { },
    });
  }

  getCouponEligibleService() {
    this.coupnService.getEligibleService(this.tenantId, this.couponMaster.id).subscribe({
      next: (res: any) => {
        if (res.items) {
          this.couponServies = res.items as CouponServicesResponse[];
          this.couponServies.forEach(o => {
            o.service_category_name = this.services.find(f => f.id == o.service_category_id).name_primary_language
          })
          this.selectedServices.next(this.couponServies);
        }
        else {
          this.selectedServices.next([]);
          this.couponServies = [];
        }
      },
      error: (error: any) => { },
    });
  }

  addService(event: any) {
    let payload: AddServiceCategoryRequest = {} as AddServiceCategoryRequest;
    payload.service_category_ids = [];
    payload.plan_ids = [];
    payload.product_sku_id = [];
    payload.service_category_ids.push(event.value.id);
    this.coupnService.addEligibleService(this.tenantId, this.couponMaster.id, payload).subscribe({
      next: (res: any) => {
        this.translate.get('ADMIN.COUPON.ERRORS.SERVICE_ADDED')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.getCouponEligibleService();
        this.reloadList = true;
      },
      error: (error: any) => {
        this.handleToastError(error);
      },
    });
  }

  removeService(couponServicesResponse: CouponServicesResponse) {
    if (this.couponServies && this.couponServies.length == 1) {
      this.translate.get('ADMIN.COUPON.ERRORS.ONE_SERVICE_REQUIRED').subscribe((translation) => {
        this.toastMessageService.showErrorMessage(translation);
      });
    }
    else {
      this.coupnService.removeEligibleService(this.tenantId, couponServicesResponse.offer_master_id, couponServicesResponse.id).subscribe({
        next: (res: any) => {
          this.translate.get('ADMIN.COUPON.ERRORS.SERVICE_REMOVED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.getCouponEligibleService();
          this.reloadList = true;
        },
        error: (error: any) => {
          this.handleToastError(error);
        },
      });
    }
  }

  handleToastError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e);
      });
    } else {
      this.toastMessageService.showErrorMessage(error);
    }
  }

  closePopup() {
    this.visible = false;
    this.closeEvent.emit({ reload: this.reloadList });
  }

}
